<template>
  <div class="abcwarp">
    <div ref="editor" />
    <MiddorCode v-model="editorVal" :wangEditor="wangEditor" />
  </div>
</template>

<script>
import E from 'wangeditor'
import htmlMenu from './htmlmenu'

const menuKey = 'htmlMenuKey'
E.registerMenu(menuKey, htmlMenu)

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean
    },
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    MiddorCode: () => import('./code.vue')
  },
  data() {
    return {
      editorVal: this.value || '',
      wangEditor: null
    }
  },
  watch: {
    editorVal(val) {
      this.wangEditor.editorVal = val
      this.$emit('change', val)
    }
  },
  mounted() {
    const editor = new E(this.$refs.editor)
    editor.config.uploadImgShowBase64 = true
    editor.config.excludeMenus = [
      'code',
      'splitLine',
      'undo',
      'redo'
    ]
    editor.config.zIndex = 1
    editor.config.height = 200
    // 颜色配置
    editor.config.colors = [
      '#000000',
      'red',
      '#1c487f',
      '#4d80bf'
    ]

    editor.create()

    editor.config.onchange = (newHtml) => {
      this.editorVal = newHtml
    }

    if (this.disabled) {
      editor.disable()
    }

    if (this.editorVal) {
      editor.txt.html(this.editorVal)
    }

    this.wangEditor = editor

    setTimeout(() => {
      const els = document.getElementsByClassName('abcwarp')
      if (els.length && window.scale) {
        els[0].style.zoom = 1 / window.scale
        els[1].style.zoom = 1 / window.scale
      }
    }, 1000)
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.abcwarp {
  position: relative;
}
</style>
